import EmptyDeskIcon from './component.jsx'
export default EmptyDeskIcon
